import React, { createContext, useContext, useState, ReactNode } from 'react';
import { User, UserRole, AuthContextType } from '../types/property.types';

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(false);

  const login = async (email: string): Promise<boolean> => {
    setLoading(true);
    try {
      // Mock login for now - replace with actual API call
      const mockUser: User = {
        id: '1',
        name: 'Admin User',
        email: email,
        role: UserRole.ADMIN,
        active: true
      };
      setUser(mockUser);
      return true;
    } catch (error) {
      console.error('Login error:', error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setUser(null);
  };

  const canEdit = user?.role === UserRole.ADMIN || user?.role === UserRole.COMERCIAL || user?.role === UserRole.RESIDENCIAL;
  const canViewOwnerData = user?.role === UserRole.ADMIN || user?.role === UserRole.COMERCIAL || user?.role === UserRole.RESIDENCIAL;

  const value: AuthContextType = {
    user,
    login,
    logout,
    canEdit,
    canViewOwnerData,
    loading
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// Export the context and types
export { AuthContext };
export type { AuthContextType };